import { PrivateUser } from 'services/api/entities';
import { actionCreator } from '../../types';
import userActionNames from './constants';
import { UserLibrarySuccessInfo, UserUpdateInfo } from './types';

export const userUpdate = actionCreator<UserUpdateInfo>(
  userActionNames.USER_UPDATE
);

export const userDelete = actionCreator<{ id: string }>(
  userActionNames.USER_DELETE
);

export const userSuccess = actionCreator<PrivateUser>(
  userActionNames.USER_SUCCESS
);

export const userFetch = actionCreator<void>(userActionNames.USER_FETCH);

export const userSetSubscriptionActive = actionCreator<void>(
  userActionNames.USER_SET_SUBSCRIPTION_ACTIVE
);

export const userReset = actionCreator<void>(userActionNames.USER_RESET);

export const songsLibrary = actionCreator<{
  page: number;
  unifiedLibraryStructure: boolean;
}>(userActionNames.USER_LIBRARY);

export const songsLibraryReset = actionCreator<void>(
  userActionNames.USER_LIBRARY_RESET
);

export const songsLibrarySuccess = actionCreator<UserLibrarySuccessInfo>(
  userActionNames.USER_LIBRARY_SUCCESS
);

export const newSongsInLibraryFlagReset = actionCreator<void>(
  userActionNames.USER_NEW_SONGS_IN_LIBRARY_FLAG_RESET
);

export const setSongListPosition = actionCreator<{ position: number }>(
  userActionNames.USER_SET_SONG_LIST_POSITION
);

export const decreaseAvailableAIGenerations = actionCreator<void>(
  userActionNames.DECREASE_AVAILABLE_AI_GENERATIONS
);
